<template>
    <div class="page">
        <v-container :class="{'px-5': phoneOnly}">
            <div v-if="program" class="px-lg-3">
                <div v-if="program.subscribed && program.subscription" class="alerts">
                    <v-alert v-if="program.subscription.status === 'suspended'" outlined color="error" type="info" text>
                        <div class="medium-text text--text">
                            <div class="multiline red--text text--darken-4 mb-2">
                                <span>Your subscription is suspended. Please recharge your wallet to reactivate.</span>
                            </div>
                        </div>
                    </v-alert>

                    <v-alert v-else-if="program.subscription.status === 'active'" color="success" icon="mdi-check" text>
                        <div class="medium-text text--text">
                        <b>You are subscribed to this program,</b> classes will be added to your calendar. <br>
                        <span v-if="program.subscription.next_charge_at">Next charge: <strong>{{dateTimeFormat(program.subscription.next_charge_at).split(' ')[0]}}</strong></span>
                        </div>
                    </v-alert>
                </div>
                <div class="d-flex flex-column flex-lg-row">
                    <div>
                        <v-card :flat="phoneOnly" :class="{'soft-shadow': pcOnly}" style="position: sticky; top: 15px;">
                            <v-card-text class="py-0" :class="{'px-0': phoneOnly}">
                                <div>
                                    <div class="mb-lg-10">
                                        <div>
                                            <v-img :width="pcOnly ? 500 : undefined" :height="pcOnly ? 300 : 205" :src="program.image_url" style="border-radius: 7px" />
                                            <v-btn v-if="program.video_url" color="primary" block class="mt-3" outlined depressed @click="videoDialog = true">
                                                <v-icon left>mdi-play-circle</v-icon>
                                                <span class="font-weight-semibold">Play video</span>
                                            </v-btn>
                                        </div>
                                        <div v-if="!program.subscribed" class="mt-3">
                                            <div class="text-center">
                                                <div class="title-text primary--text font-weight-bold" style="font-size: 1.5rem;">{{moneyFormat(program.price, true)}}</div>
                                                <div class="details-text primary--text text--darken-2">{{program.subscription_type === 'monthly' ? 'per month' : 'one-time payment'}}</div>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <v-btn v-if="!program.subscribed" large depressed color="primary" block style="font-size: 1rem" @click="subscribeDialog = true">
                                                <strong>
                                                    Subscribe
                                                </strong>
                                                <v-icon color="secondary" right size="25" class="ms-2">mdi-chevron-right</v-icon>
                                            </v-btn>
                                            <v-btn v-else large depressed color="success" block style="font-size: 1rem" disabled>
                                                <strong>
                                                    <v-icon left>mdi-check-circle</v-icon>
                                                    Subscribed
                                                </strong>
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>
                    <div class="flex-grow-1 py-2 ps-lg-10">
                        <div>
                            <h1 v-if="pcOnly" class="program-title strong-text--text mb-2">
                                <span>{{program.name}}</span>
                            </h1>
                            <h2 v-else class="program-title strong-text--text mb-2">
                                <span>{{program.name}}</span>
                            </h2>
                            <div class="d-flex mb-3">
                                <v-chip color="primary" small label>{{program.category_name}}</v-chip>
                                <v-chip v-if="program.subscribed" dark small label color="success" class="ms-2">Subscribed</v-chip>
                            </div>
                            <v-divider class="mb-4"></v-divider>
                            <div v-if="program.description" class="description medium-text" v-html="parseText(program.description)"></div>
                        </div>
                    </div>
                </div>

            </div>
        </v-container>

        <v-dialog v-if="program && program.video_url" transition="slide-y-transition" scrollable v-model="videoDialog" max-width="700" overlay-opacity="0.8" overlay-color="#000">
            <v-card>
                <v-card-title></v-card-title>
                <v-card-text class="pt-4">
                    <div class="mt-6">
                        <iframe v-if="program.video_url.search('youtube.com/embed') !== -1" style="width: 100%; border-radius: 12px;" :style="`min-height: ${phoneOnly ? 250 : 400}px`" :src="program.video_url" :title="program.name" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        <video v-else controls style="width: 100%;" :style="`min-height: ${phoneOnly ? 250 : 300}px`">
                            <source :src="program.video_url" />
                        </video>
                    </div>
                    <v-btn icon absolute top right @click="videoDialog = false;">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog transition="slide-y-transition" v-model="subscribeDialog" max-width="500">
            <v-card>
                <v-card-title class="mb-3">Subscribe</v-card-title>
                <v-card-text>
                    <div class="mb-4">
                        <div class="medium-text text--text mb-2">
                            Begin your journey with:
                        </div>
                        <div class="title-text primary--text mb-2">{{program.name}}</div>
                        <div class="medium-text text--text">
                            Structured learning with trusted Al-Azhar guidance.
                        </div>
                        <v-divider class="my-4"></v-divider>
                        <div class="d-flex justify-space-between align-center mb-2">
                            <span class="medium-text">Subscription fees:</span>
                            <span class="title-text primary--text font-weight-bold">{{moneyFormat(program.price, true)}}</span>
                        </div>
                        <div class="medium-text muted--tex">It'll be deducted from your balance.</div>
                        <div v-if="program.subscription_type === 'monthly'" class="d-flex justify-space-between align-center">
                            <span class="medium-text">Subscription Type:</span>
                            <v-chip small color="primary" outlined>{{program.subscription_type === 'monthly' ? 'Monthly' : 'One-time'}}</v-chip>
                        </div>
                        <v-alert v-if="program.subscription_type === 'monthly'" type="primary darken-1" dense text class="mt-4">
                            <span class="details-text">You will be charged automatically on the 1st of each month.</span>
                        </v-alert>
                        <v-alert v-if="insufficientBalance" dense- type="info" color="secondary darken-1" outlined v-ripple class="e-link mt-4" @click="$router.push({name: 'wallet', query: {recharge: 1}})">
                            <div class="text--text font-weight-semibold">Insufficient balance. <span class="secondary--text text--darken-2">Click Here to recharge your wallet</span></div>
                        </v-alert>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="muted" @click="subscribeDialog = false" :disabled="subscribing">Cancel</v-btn>
                    <v-btn color="primary" class="px-4" depressed @click="confirmSubscribe" :loading="subscribing" :disabled="subscribing">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkify-html';

// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: "Program",
    data(){
        return {
            program: null,
            videoDialog: false,
            subscribeDialog: false,
            loading: false,
            subscribing: false,
        }
    },
    computed: {
        id(){
            return this.$route.params.id;
        },
        ...GlobalComputed
    },
    watch: {
        id(){
            this.loadData();
        },
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        loadData(){
            if (!this.loading){
                this.loading = true;
                return this.$store.dispatch('getProgram', {id: this.id}).then(response=>{
                    this.program = response.data.data;
                    this.loading = false;
                }).catch((e)=>{
                    this.$router.push({name: 'programs'});
                    this.loading = false;
                    console.error(e);
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        confirmSubscribe(){
            if (!this.subscribing){
                this.subscribing = true;
                return this.$store.dispatch('subscribeToProgram', {id: this.id}).then(response=>{
                    this.subscribing = false;
                    this.subscribeDialog = false;
                    this.showMsg('Successfully subscribed to program!', 'success');
                    // Reload program data to get updated subscription status
                    this.loadData();
                }).catch(error=>{
                    this.subscribing = false;
                    if (error.response){
                        const status = error.response.status;
                        const data = error.response.data;
                        
                        if (status === 402){
                            // Insufficient balance
                            this.showMsg('Insufficient balance. Please recharge your wallet.', 'warning');
                            this.insufficientBalance = true;
                            // this.subscribeDialog = false;
                            // Optionally redirect to wallet page
                            // this.$router.push({name: 'wallet'});
                        } else if (status === 403){
                            // Already subscribed
                            this.showMsg('You are already subscribed to this program.', 'warning');
                            this.subscribeDialog = false;
                            this.loadData(); // Refresh to get updated status
                        } else if (status === 404){
                            // Program not found
                            this.showMsg('Program not found.', 'error');
                            this.subscribeDialog = false;
                            this.$router.push({name: 'programs'});
                        } else if (status === 500){
                            // Payment processing failed
                            this.showMsg('Failed to process payment. Please try again.', 'error');
                        } else {
                            // Other errors
                            const message = data.message || 'Error occurred during subscription';
                            this.showMsg(message, 'error');
                        }
                    } else {
                        this.showMsg('Error occurred during subscription', 'error');
                    }
                })
            }
        },
        escapeHtmlText(text){
            // to prevent XSS attacks
            return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        },
        urlify(text){
            const options = { defaultProtocol: 'https' , target: '_system'};
            return linkifyHtml(text, options);
        },
        parseText(text){
            let html = this.escapeHtmlText(text);
            html = text.replaceAll(/\*\*.*?\*\*?/ig, match=>{
                return `<strong class="strong-text--text">${match.replaceAll('**', '')}</strong>`;
            }).replaceAll(/\#\#.*?\#\#?/ig, match=>{
                return `<h2 class="description-title primary--text">${match.replaceAll('##', '')}</h2>`;
            });

            html = this.urlify(html);
            return html
        },
        ...GlobalMethods
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>
    .program-title{
        line-height: 2.1rem;
    }
    .description{
        white-space: pre-line;
        font-size: 0.9rem;
        line-height: 1.5rem;
    }
    .multiline{
        white-space: pre-line;
    }
    .description-title{
        font-weight: bold;
        font-size: 1.8rem;
    }
</style>
